<template>
    <div class="container-register">
        <div class="title">
            <router-link to="/">
                <img src="../assets/abi-vertical.png" alt="" class="img-title" />
            </router-link>
        </div>
        <div class="wrap-content">
            <div class="content-register">
                <p>Basic Register</p>
                <form @submit.prevent="register">
                    <div class="form-group">
                        <label for="">Nama lengkap *</label>
                        <input type="text" class="form-input" placeholder="Masukkan nama lengkap" v-model="$v.form.name.$model" />
                        <div v-if="$v.form.name.$error">
                            <div class="form-error" v-if="!$v.form.name.required">
                                Nama lengkap tidak boleh kosong
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Email *</label>
                        <input type="email" class="form-input" placeholder="Masukkan alamat email" v-model="$v.form.email.$model" @blur="checkAccountEmail" />
                        <div v-if="$v.form.email.$error">
                            <div class="form-error" v-if="!$v.form.email.required">
                                Email tidak boleh kosong
                            </div>
                            <div class="form-error" v-if="!$v.form.email.email">
                                Format email salah
                            </div>
                        </div>
                        <div class="form-error" :class="statusEmail == 400 ? 'display-error' : 'undisplay-error'">
                            Email yang anda gunakan sudah terdaftar
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">No Telepon *</label>
                        <input
                            type="text"
                            class="form-input"
                            placeholder="Masukkan no telepon aktif"
                            v-model="$v.form.phone_number.$model"
                            @keyup="form.phone_number = form.phone_number.replace(/[^\d]/g, '')"
                            @blur="checkAccountPhone"
                        />
                        <div v-if="$v.form.phone_number.$error">
                            <div class="form-error" v-if="!$v.form.phone_number.required">
                                No telepon tidak boleh kosong
                            </div>
                            <div class="form-error" v-if="!$v.form.phone_number.minLength">
                                No telepon minimal 10 karakter
                            </div>
                            <div class="form-error" v-if="!$v.form.phone_number.maxLength">
                                No telepon maksimal 14 karakter
                            </div>
                        </div>
                        <div class="form-error" :class="statusPhone == 1001 ? 'display-error' : 'undisplay-error'">
                            No Telepon yang anda gunakan sudah terdaftar
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Password *</label>
                        <input type="password" class="form-input" placeholder="Masukkan password" v-model="$v.form.password.$model" />
                        <div v-if="$v.form.password.$error">
                            <div class="form-error" v-if="!$v.form.password.required">
                                Password tidak boleh kosong
                            </div>
                            <div class="form-error" v-if="!$v.form.password.minLength">
                                Password minimal 8 karakter
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="">Konfirmasi password *</label>
                        <input type="password" class="form-input" placeholder="masukkan konfirmasi password" v-model="$v.form.confirm_password.$model" />
                        <div v-if="$v.form.confirm_password.$error">
                            <div class="form-error" v-if="!$v.form.confirm_password.required">
                                Konfirmasi password tidak boleh kosong
                            </div>
                            <div class="form-error" v-if="!$v.form.confirm_password.minLength">
                                Konfirmasi password minimal 8 karakter
                            </div>
                        </div>
                        <div class="form-error" v-show="status == 405">
                            Password tidak sama, silahkan masukkan ulang password
                        </div>
                    </div>
                    <div class="form-group form-platform">
                        <label for="platform">Platform</label>
                        <div class="radio">
                            <label class="trv-radio label-radio" v-for="(data, i) in reverseData" :key="i" @change="updatePlatform">
                                <input type="radio" name="gender" v-model="platform" :value="data.code" required />
                                <span class="outer"><span class="inner"></span></span>
                                {{ data.name }}
                            </label>
                        </div>
                    </div>

                    <div class="error" v-show="message == 401">
                        Password tidak sama, silahkan masukkan ulang password
                    </div>
                    <div class="error" v-show="status == 403">
                        No Telepon anda tidak aktif, pastikan anda memasukkan no telepon akti anda
                    </div>
                    <div class="error" v-show="status == 400">
                        Akun anda sudah terdaftar
                    </div>
                    <div class="wrap-button">
                        <button class="btn-primer" type="submit">
                            <div v-show="isLoading == false">Daftar</div>
                            <Loading v-show="isLoading" />
                        </button>
                    </div>
                </form>

                <!-- v-show="selected" -->
                <div class="self-modal" v-show="selected">
                    <div class="content-modal">
                        <div class="title-modal">
                            <span v-show="isLoadingResendOtp == false">Masukan Kode Aktivasi</span>
                            <span v-show="isLoadingResendOtp">Aktivasi Email Anda</span>
                        </div>
                        <div class="body-modal">
                            <div class="content-body" v-show="isLoadingResendOtp">
                                <div v-if="form.platform == 'Jafets' || form.platform == 'MetaTrader 5'">
                                    Silahkan Menunggu email dari pialang
                                </div>
                                <div v-else>
                                    Selamat email Anda berhasil terdaftar, silahkan cek email untuk melakukan verifikasi akun
                                </div>
                            </div>
                            <div class="content-body" v-show="isLoadingResendOtp == false">
                                Kami mengirim kode OTP ke No <br />
                                {{ form.phone_number }}
                            </div>
                            <div class="wrap-otp-input" v-show="isLoadingResendOtp == false">
                                <!-- <input
                  class="inputs"
                  type="text"
                  v-for="(data, index) in index"
                  :key="index"
                  @keyup="otpNumber($event, index)"
                  maxlength="1"
                  v-model="valuePart[index]"
                  @input="emitInput()"
                /> -->
                                <div id="divOuter">
                                    <div id="divInner">
                                        <input id="partitioned" type="text" maxlength="6" v-model="numberOtp" autocomplete="off" />
                                    </div>
                                </div>
                                <div class="error-otp" v-show="status == 401">
                                    Kode OTP Tidak Boleh kosong
                                </div>
                                <div class="error-otp" v-show="status == 400">
                                    Kode OTP yang anda masukan salah
                                </div>
                                <div class="error-otp" v-show="status == 404">
                                    maaf sistem sedang mengalami masalah teknis, coba beberapa menit lagi
                                </div>
                            </div>
                        </div>
                        <div class="footer-modal">
                            <div v-show="isLoadingResendOtp == false">
                                <div class="btn-primer btn-otp" @click="submitOtp">
                                    <div v-show="isLoadingOtp == false">Verifikasi</div>
                                    <Loading v-show="isLoadingOtp" />
                                </div>
                                <div class="resend-code">
                                    Tidak menerima kode?
                                    <span @click="resendOTP"> Kirim Ulang Kode </span>
                                </div>
                            </div>
                            <div v-show="isLoadingResendOtp">
                                <router-link to="/login">
                                    <button type="button" class="btn-primer">
                                        OK
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sign-in">
                <p>Sudah Punya Akun?</p>
                <router-link class="login" to="/login"><button class="btn-scondary">Masuk</button> </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email, minLength, maxLength } from "vuelidate/lib/validators";
import Loading from "../assets/Loading.vue";
import axios from "axios";
import sha256 from "sha256";

export default {
    components: {
        Loading,
    },
    data() {
        return {
            form: {
                email: "",
                password: "",
                phone_number: "",
                // username: "",
                name: "",
                confirm_password: "",
                platform: [],
            },
            dataPlatform: [],
            platform: "",
            message: "",
            selected: false,
            isLoading: false,
            isLoadingOtp: false,
            isLoadingResendOtp: false,
            valuePart: [],
            numberOtp: "",
            token: "",
            index: 6,
            status: "",
            statusUsername: "",
            statusEmail: "",
            statusPhone: "",
            date: 60,
        };
    },
    validations: {
        form: {
            name: {
                required,
            },
            email: {
                required,
                email,
            },
            phone_number: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(14),
            },
            password: {
                required,
                minLength: minLength(8),
            },
            confirm_password: {
                required,
                minLength: minLength(8),
            },
        },
    },
    mounted() {
        axios.get("/v2/master_data/platform").then((res) => {
            this.dataPlatform = res.data.data;
            // this.dataPlatform.slice().reverse();
        });
    },
    methods: {
        updatePlatform(event) {
            this.form.platform[0] = event.target.value;
        },
        register() {
            this.$v.form.$touch();
            if (this.$v.form.$error) {
                return;
            }
            let data = {
                email: this.form.email,
                password: sha256(this.form.password),
                phonenumber: this.form.phone_number,
                username: this.form.username,
                fullname: this.form.name,
                platform: this.form.platform,
            };
            this.isLoading = true;
            if (this.form.platform.length != 0) {
                this.message = 0;
                this.$store
                    .dispatch("register", data)
                    .then((res) => {
                        if (res.data.status == 200) {
                            this.selected = true;
                            this.token = res.data.data.token;
                            this.isLoading = false;
                            this.coundounTimer();
                        }
                        this.status = "";
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        this.status = error.response.status;
                    });
            } else {
                // this.message = 401;
                this.$toast.error("Pastikan semua inputan telah terisi");
                this.isLoading = false;
            }
        },
        submitOtp() {
            this.isLoadingOtp = true;
            let data = {
                phonenumber: this.form.phone_number,
                otp: this.numberOtp,
                email: this.form.email,
                token: this.token,
            };
            if (this.numberOtp == "") {
                this.status = 401;
                this.isLoadingOtp = false;
            } else {
                this.status = 202;
                axios
                    .post("/v2/user/register/verify/otp", data)
                    .then((res) => {
                        if (res.data.status == 200) {
                            this.status = res.data.status;
                            this.isLoadingOtp = false;
                            this.isLoadingResendOtp = true;
                        }
                    })
                    .catch((error) => {
                        this.isLoadingOtp = false;
                        this.status = error.response.status;
                    });
            }
        },
        emitInput() {
            this.numberOtp = this.valuePart[0] + this.valuePart[1] + this.valuePart[2] + this.valuePart[3] + this.valuePart[4] + this.valuePart[5];
        },
        resendOTP() {
            let data = {
                email: this.form.email,
                phonenumber: this.form.phone_number,
                token: this.token,
            };
            axios.post("/v2/user/register/resend/otp", data).then((res) => {
                if (res.status == 200) {
                    this.notif();
                }
            });
        },

        notif() {
            this.$notify({
                group: "foo",
                title: "<h5>Berhasil mengirim ulang otp</h5>",
                type: "success",
            });
        },

        otpNumber(event, i) {
            const key = event.key;
            const pattern = /[0-9]/;

            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }

            let inputData = document.getElementsByClassName("inputs");
            let next;
            if (!key) {
                return;
            } else if (key === "Backspace") {
                this.valuePart[i] = "";
            } else if (key === "ArrowLeft") {
                next = inputData[i - 1];
                if (i > 0) {
                    next.focus();
                }
            } else if (key === "ArrowRight") {
                next = inputData[i + 1];
                if (i < inputData.length - 1) {
                    next.focus();
                }
            } else {
                next = inputData[i + 1];
                if (i < inputData.length - 1) {
                    next.focus();
                }
            }
        },
        isNumber(event) {
            const pattern = /[0-9]/;

            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
                event.preventDefault();
            }
        },
        checkAccountUsername() {
            axios
                .post("/v2/user/register/check", {
                    username: this.form.username,
                })
                .then((res) => {
                    this.statusUsername = res.status;
                })
                .catch((error) => {
                    this.statusUsername = error.response.status;
                    console.clear();
                });
        },
        checkAccountEmail() {
            axios
                .post("/v2/user/register/check", {
                    email: this.form.email,
                })
                .then((res) => {
                    this.statusEmail = res.status;
                })
                .catch((error) => {
                    this.statusEmail = error.response.status;
                });
        },
        checkAccountPhone() {
            this.statusPhone = "";
            axios
                .post("/v2/user/register/check", {
                    phonenumber: this.form.phone_number,
                })
                .then((res) => {
                    this.statusPhone = res.status;
                })
                .catch((error) => {
                    this.statusPhone = error.response.data.data.status_code;
                });
        },
        coundounTimer() {
            if (this.date > 0) {
                setInterval(() => {
                    this.date -= 1;
                    this.coundounTimer();
                }, 1000);
            }
        },
    },

    computed: {
        response() {
            let status = this.$store.state.message;
            return status;
        },

        reverseData() {
            return this.dataPlatform.slice().reverse();
        },
    },

    watch: {
        "form.confirm_password"() {
            if (this.form.confirm_password) {
                if (this.form.confirm_password != this.form.password) {
                    this.status = 405;
                } else {
                    this.status = "";
                }
            }
        },
    },
};
</script>

<style scoped>
#partitioned {
    padding: 0 0 5px 15px;
    letter-spacing: 15px;
    border: 0;
    border-bottom: 2px solid #707070;
    width: 250px;
    /* min-width: 280px; */
    text-align: center;
    font-size: 28px;
    /* background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px; */
}

#partitioned:focus {
    outline: none;
}

#divInner {
    left: 0;
    position: sticky;
}

#divOuter {
    width: 250px;
    overflow: hidden;
}

.container-register {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(197, 151, 51, 0.4);
    flex-direction: column;
    padding: 30px 0;
}

.wrap-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.title {
    text-align: center;
}

.img-title {
    height: 98px;
    margin-bottom: 40px;
    margin-right: 50px;
}

.form-platform,
.form-checkbox {
    display: flex;
    align-items: center;
}

.label--checkbox {
    margin: 0 28px 0 13px;
}

.content-register {
    width: 45%;
    background: white;
    padding: 30px 50px;
    border-radius: 5px;
    border: 1px solid #ddd;
    box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
}

.sign-in {
    width: 200px;
    background: var(--primary);
    height: 430px;
    color: white;
    padding: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0 10px 10px 0;
}

.sign-in p {
    font-size: 20px;
    margin-bottom: 40px;
}

.btn-scondary {
    background: transparent;
    font-size: 13px;
    width: 125px;
    height: 39px;
    border: solid 1px var(--scondary);
}

label {
    font-size: 13px;
    width: 32%;
    display: inline-block;
    margin-bottom: 0px;
}

.label-radio {
    width: 70%;
    flex-shrink: 0;
}

.form-group {
    margin: 0 0 12px;
}

.form-input,
select {
    width: 68%;
    font-size: 12px;
    border-radius: 0;
    height: 37px;
    border: none;
    border-bottom: 1px solid #9a9a9a;
    padding: 0 5px;
    background: #fff;
    box-shadow: none;
}

::placeholder {
    color: #9a9a9a;
}

.form-input:focus,
select:focus {
    box-shadow: none;
    border-color: #c59733;
}

option {
    padding: 5px;
}

select option:disabled {
    /* color: #000;
    font-weight: bold; */
    cursor: not-allowed;
}

.content-register p {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 35px;
    position: relative;
}

.content-register p::after {
    content: "";
    width: 50px;
    height: 3px;
    position: absolute;
    background: #c59733;
    bottom: -4px;
    left: 0px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}

.container {
    width: 90%;
}

.error {
    border: solid 1px;
    font-weight: bold;
    width: 94%;
    text-align: center;
    margin-top: 45px;
    border-radius: 5px;
}

.form-error {
    font-size: 12px;
    margin: 5px 33%;
    width: 65%;
    color: #e74c3c;
}

.succes {
    text-align: center;
    padding: 15px;
    border: solid 1px;
    font-weight: bold;
}

/* .wrap-otp-input {
  display: block;
  margin: 10px auto;
  width: 54%;
  position: relative;
  top: 25%;
} */

.inputs {
    background-color: transparent;
    border: none;
    border-bottom: 2px solid gray;
    display: inline-block;
    font-size: 20px;
    margin: 0 5px;
    width: 1.5rem;
    text-align: center;
}

.btn-otp {
    margin: 0 auto;
}

.content-body {
    padding: 13px;
    text-align: center;
}

.resend-code {
    font-size: 13px;
}

.resend-code span {
    font-size: 13px;
    cursor: pointer;
    color: #1f354a;
}

.title-modal {
    text-align: center;
}

.content-modal {
    width: 420px;
}

.error-otp {
    color: #e74c3c;
    text-align: center;
    font-size: 13px;
    width: 75%;
    margin: 0 auto;
    position: relative;
    top: 24%;
}

.body-modal {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 5rem;
}

.footer-modal {
    margin: 45px 22px 10px;
}

.wrap-button {
    display: flex;
    justify-content: flex-end;
    padding: 40px 0px 0px;
}

.have-account {
    font-size: 12px;
}

.have-account .login {
    font-weight: bold;
    color: #c59733;
}

.btn-primer {
    font-size: 14px;
}

.display-error {
    display: block;
}

.undisplay-error {
    display: none;
}

@media (max-width: 1024px) {
    .content-register {
        width: 60%;
    }
    .form-input {
        width: 65%;
    }
}

@media (max-width: 720px) {
    .container-register {
        display: block;
        padding: 20px;
    }

    .title {
        text-align: left;
    }

    .img-title {
        height: 40px;
    }

    .wrap-content {
        flex-direction: column;
        gap: 3rem;
    }

    .content-register {
        width: 100%;
        padding: 30px;
    }

    .form-platform,
    .form-checkbox {
        flex-direction: column;
    }

    .radio {
        flex-direction: column;
        width: 100%;
    }

    label,
    .form-input {
        width: 100%;
    }

    .form-error {
        margin: 10px 5px;
    }

    .sign-in {
        width: 100%;
        height: 20px;
        background: transparent;
        flex-direction: row;
        align-items: center;
        color: #707070;
        font-size: 13px;
    }

    .sign-in p {
        margin-bottom: 0;
        font-size: 12px;
    }

    .wrap-button {
        display: block;
        text-align: center;
    }

    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        background: var(--primary);
        border: none;
        color: #fff;
        width: 70px;
        height: 30px;
        margin-left: 15px;
    }

    .self-modal {
        right: 0;
        width: 100%;
    }

    .content-modal {
        width: 90%;
    }
}
</style>
